export default "__VITE_ASSET__5204cf9f__"